export default __webpack_public_path__ + "static/smb-desktop-64b03bc6b24251aa789a5fdb5822d7ae.png";